<template>
  <div class="h-full flex items-center onboarding-container">
    <div class="w-full bg-white h-screen shadow-lg relative z-10 flex flex-col px-4 overflow-y-auto pb-10">
      <div class="w-full max-w-md mx-auto mt-8">
        <div class="flex items-center space-x-2 mb-12">
          <div 
            v-for="step in 4" 
            :key="step"
            class="flex-1"
          >
            <div 
              class="h-1.5 rounded-full"
              :class="{
                'bg-[#F54239]': step - 1 <= activeStep,
                'bg-gray-200': step - 1 > activeStep
              }"
            ></div>
          </div>
        </div>
      </div>

      <div class="flex-1 flex flex-col items-center max-w-lg w-full mx-auto -mt-5">
        <div class="w-full text-center">
          <img :src="FeedBearLogo" :width="'120px'" class="mx-auto mb-10" />
          <h2 class="text-2xl font-semibold text-gray-900 mb-2">
            {{ stepTitles[activeStep] }}
          </h2>
          <p class="text-gray-600 mb-10">
            {{ stepHelp[activeStep] }}
          </p>
        </div>

        <div class="w-full">
          <NewProject
            v-model="project"
            v-if="activeStep === 0"
            @submit="nextStep"
            class="w-full"
          ></NewProject>

          <NewBoard
            v-model="board"
            :project="project"
            v-if="activeStep === 1"
            @submit="nextStep"
            class="w-full"
          ></NewBoard>

          <NewPosts
            v-model="posts"
            :board="board"
            :project="project"
            v-if="activeStep === 2"
            @submit="nextStep"
            class="w-full"
          ></NewPosts>

          <NewRoadmap 
            v-if="activeStep === 3" 
            :project="project"
            class="w-full"
          ></NewRoadmap>
        </div>
      </div>
    </div>

    <div class="w-1/2 browser-container hidden">
      <BrowserBoard
        v-if="activeStep <= 2"
        :project="project"
        :board="board"
        :posts="posts"
        :active-step="activeStep"
        :status-name="statusName"
      ></BrowserBoard>
      <BrowserRoadmap
        v-else
        :project="project"
        :board="board"
        :posts="posts"
      ></BrowserRoadmap>
    </div>
  </div>
</template>

<script>
import FeedBearLogo from "../images/logo.png";

import NewProject from "./new_project";
import NewBoard from "./new_board";
import NewPosts from "./new_posts";
import NewRoadmap from "./new_roadmap";

import BrowserBoard from "./browser_board";
import BrowserRoadmap from "./browser_roadmap";

export default {
  props: ["status-name"],

  data() {
    return {
      FeedBearLogo,
      project: {
        id: 0,
        name: "",
        url: "",
        logo: null
      },
      board: {
        id: 0,
        name: "💡 Feature Requests"
      },
      posts: {
        first: {
          id: 0,
          title: "",
          status: this.statusName.done,
          human_status: this.statusName.done,
        },
        second: {
          id: 0,
          title: "",
          status: this.statusName.in_progress,
          human_status: this.statusName.in_progress,
        },
        third: {
          id: 0,
          title: "",
          status: this.statusName.planned,
          human_status: this.statusName.planned
        }
      },
      activeStep: 0,
      stepTitles: [
        "Create your project",
        "Set up your first feedback board",
        "Add some example feedback",
        "Ready to launch! 🎉"
      ],
      stepHelp: [
        "Create a dedicated space where your users can share their feedback and ideas for your product.",
        "Start with a feature requests board - you can add more boards later for bugs, questions, or other feedback types.",
        "Add a few example posts to show users how to share feedback. This will help kickstart engagement.",
        "Your feedback portal is ready! Share the link with your users and start collecting valuable feedback."
      ]
    };
  },

  mounted() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "signupV2",
      });
    },

  components: {
    NewProject,
    NewBoard,
    NewPosts,
    NewRoadmap,
    BrowserBoard,
    BrowserRoadmap
  },

  methods: {
    nextStep() {
      this.activeStep++;
    }
  }
};
</script>

<style scoped>
.browser-container {
  background-color: #fee2e2;
  @apply min-h-screen flex-col justify-center relative z-0 px-3;
}
</style>
